// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Jv-S4","content":"styles_content__3y6VY"};